function devGatewayOrigin(): string | null {
  if (!import.meta.env.DEV || typeof window === 'undefined') return null;
  return window.location.origin;
}

/** Central Hub API gateway base URL (includes `/api/v1`) — HRM APIs. */
export const API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL?.trim() ||
  (devGatewayOrigin() ? `${devGatewayOrigin()}/api/v1` : 'http://localhost:65276/api/v1');

/**
 * Auth Service via API gateway (`/auth/*` → Auth Service): login, refresh, sessions, /me.
 */
export const AUTH_API_BASE_URL =
  import.meta.env.VITE_AUTH_API_BASE_URL?.trim() ||
  devGatewayOrigin() ||
  'http://localhost:65276';

export const HRM_PRODUCT_CODE = 'HRM';

export const AUTH_STORAGE_KEYS = {
  accessToken: 'hrm_access_token',
  refreshToken: 'hrm_refresh_token',
  sessionId: 'hrm_session_id',
  /** Friendly device/session label from login/refresh (UA parsing on auth-service). */
  deviceName: 'hrm_device_name',
  orgCode: 'hrm_org_code',
  domainCode: 'hrm_domain_code',
} as const;

/** Warn when local HRM UI talks to a remote API (common cause of "Organization not found"). */
if (import.meta.env.DEV && typeof window !== 'undefined') {
  const onLocalDevHost =
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    /^192\.168\.\d{1,3}\.\d{1,3}$/.test(window.location.hostname) ||
    /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(window.location.hostname);
  const remoteApi =
    API_BASE_URL.includes('iqsetters.in') || AUTH_API_BASE_URL.includes('iqsetters.in');
  const localhostApi =
    API_BASE_URL.includes('localhost') || AUTH_API_BASE_URL.includes('localhost');
  if (onLocalDevHost && remoteApi) {
    console.warn(
      '[HRM] API URLs point to a remote host while the app runs on localhost. ' +
        'Client onboard (Central Hub :3002) and HRM login must use the same VITE_API_BASE_URL / VITE_AUTH_API_BASE_URL. ' +
        'See IQ_HRMS-WebApp/.env.example.',
    );
  }
  if (onLocalDevHost && localhostApi && window.location.hostname !== 'localhost') {
    console.warn(
      '[HRM] VITE_* URLs point to localhost while the app is opened via LAN IP. ' +
        'Remove VITE_API_BASE_URL / VITE_AUTH_API_BASE_URL from .env so the dev proxy is used, ' +
        'or set them to this machine IP (e.g. http://192.168.1.51:65276).',
    );
  }
}
